import { render, staticRenderFns } from "./CreateInventoryView.vue?vue&type=template&id=e87f4336&"
import script from "./CreateInventoryView.vue?vue&type=script&lang=ts&"
export * from "./CreateInventoryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports